import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {FDSBridgeRootState as RootState} from '../../interfaces'
import common from '../../slices/common'
import fds from '../../slices/fds'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        common,
        fds,
        router: routerReducer,
    })

export default createRootReducer
